<template>
    <div class="lp_Tabs">
    </div>
</template>

<script>
  export default {
    name: "lp_Tabs",
    props:{
      title:{//标题
        type:String,
        default:'标题'
      },
      //是否展示下划线
      isShowBorder:{
        type:Boolean,
        default:true
      },
      //是否展示更多
      isShowMore:{
        type:Boolean,
        default:true
      },
      //查看更多跳转地址
      moreHref:{
        type:String,
        default:''
      },
    },
    data () {
      return{

      }
    },
    methods: {
      //查看更多
      moreClick(){
        this.$router.push({path:moreHref});
      }
    },
  }
</script>

<style scoped lang="less">
.lp_Tabs{
  
}
</style>


// WEBPACK FOOTER //
// src/components/tabs/index.vue